jQuery(document).ready(function () {
  jQuery('li.gf_readonly textarea, li.gf_readonly input').attr('readonly', 'readonly');
  jQuery('li.gf_readonly select option').each(function () {
    if (this.selected && (this.text !== '--' || this.text !== '')) {
      jQuery(this).parent().attr('readonly', 'readonly').trigger('chosen:updated');
    }
  });
  jQuery('li.gf_disabled textarea, li.gf_disabled input').attr('disabled','disabled');
  jQuery('li.gf_disabled select option').each(function() {
    if (this.selected && this.text !== '--' && this.text !== '') {
      jQuery(this).parent().attr('disabled','disabled');
    }
  });
});
